import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import HelpButton from '../HelpButton/HelpButton';
import { ModalContent } from '../../Assignment/style';

const ConfirmationModal = props => {
  const {
    title,
    children,
    onConfirm,
    onClose,
    loading,
    tooltipContent,
    buttonTextConfirm,
    buttonTextCancel,
    testId,
  } = props;

  const { t, dir } = useTranslation();

  return (
    <Modal testId={testId} dir={dir}>
      <div className={`confirmation-modal ${loading ? 'is-loading' : ''}`}>
        {tooltipContent && (
          <div
            data-testid="confirmation-modal-help"
            className="confirmation-modal__help"
          >
            <HelpButton tooltipContent={t(tooltipContent)} />
          </div>
        )}
        {onClose && (
          <button
            data-testid="confirmation-modal-closeButton"
            className="confirmation-modal__close-button"
            onClick={onClose}
          >
            <i className="confirmation-modal__icon assignments-icon icon--cancel" />
          </button>
        )}
        <h1 className="confirmation-modal__title">{t(title)}</h1>
        <ModalContent>{children}</ModalContent>
        <div className="confirmation-modal__buttons">
          {onClose && (
            <button
              data-testid="confirmation-modal-cancelButton"
              className="confirmation-modal__button confirmation-modal__button--cancel"
              onClick={onClose}
            >
              {t(buttonTextCancel)}
            </button>
          )}
          <button
            data-testid="confirmation-modal-confirmButton"
            className="confirmation-modal__button confirmation-modal__button--confirm"
            onClick={e => {
              if (!loading) {
                onConfirm(e);
              }
            }}
          >
            {loading ? (
              <span
                data-testid="confirmation-modal-spinner"
                className="confirmation-modal__spinner"
              />
            ) : (
              t(buttonTextConfirm)
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;

ConfirmationModal.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  tooltipContent: PropTypes.node,
  buttonTextConfirm: PropTypes.string,
  buttonTextCancel: PropTypes.string,
  testId: PropTypes.string,
};

ConfirmationModal.defaultProps = {
  tooltipContent: null,
  testId: '',
  buttonTextConfirm: 'Yes',
  buttonTextCancel: 'No',
  onClose: undefined,
};
